import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Cookie } from 'lucide-react';

interface CookieSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CookieSettingsDialog: React.FC<CookieSettingsDialogProps> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Cookie className="h-5 w-5" />
            {t('cookie_banner.info.title.translation')}
          </DialogTitle>
          <DialogDescription>
            {t('cookie_banner.info.description.translation')}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <h4 className="font-semibold text-sm">
              {t('cookie_banner.info.essential.title.translation')}
            </h4>
            <p className="text-sm text-muted-foreground">
              {t('cookie_banner.info.essential.description.translation')}
            </p>
            <ul className="ml-2 list-inside list-disc space-y-1 text-sm text-muted-foreground">
              <li>{t('cookie_banner.info.essential.auth.translation')}</li>
              <li>{t('cookie_banner.info.essential.language.translation')}</li>
              <li>
                {t('cookie_banner.info.essential.preferences.translation')}
              </li>
            </ul>
          </div>
        </div>

        <div className="flex justify-end">
          <Button onClick={() => onOpenChange(false)}>
            {t('cookie_banner.info.close.translation')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CookieSettingsDialog;
